import classNames from 'classnames';
import Typography from 'components/generics/texts/Typography';
import NewTabLink from 'components/next/NewTabLink';
import { PROPERTY_DOCUMENTS } from 'consts/legalDocs';
import { LEND_DOCUMENTS_QUERY } from 'graphql/lend/lendDocumentsQuery';
import { useRealEstateQuery } from 'hooks/api/graphql/real_estate';
import classes from 'pages/place-order/components/DebtOrderSummary/components/LiquidityDisclosure/index.module.scss';
import React, { HTMLAttributes } from 'react';
import { DocObject } from 'types/legal-documents';

export const LIQUIDITY_DISCLOSURE_URI = 'https://www.landa.app/help-center';

const LiquidityDisclosure = ({ className }: HTMLAttributes<HTMLDivElement>) => {
  const { data } = useRealEstateQuery(LEND_DOCUMENTS_QUERY);
  const docs = data?.landaFinancingReit?.documents;

  return (
    <div className={classNames(classes.container, className)}>
      <Typography className={classes.title}>Liquidity Disclosure</Typography>
      <Typography className={classes.text}>
        Shares of Lend can be redeemed through our redemption plan after a
        minimum of a 12 month holding period. Read more in the{' '}
        <NewTabLink
          className={classes.link}
          to={LIQUIDITY_DISCLOSURE_URI}
        >
          Help Center
        </NewTabLink>{' '}
        and in the{' '}
        <NewTabLink
          className={classes.link}
          to={
            docs?.find(
              (doc: DocObject) =>
                doc.title === PROPERTY_DOCUMENTS.OFFERING_CIRCULAR
            )?.uri ?? ''
          }
        >
          Offering Circular
        </NewTabLink>
        .
      </Typography>
    </div>
  );
};

export default LiquidityDisclosure;
